// extracted by mini-css-extract-plugin
export default {"mainContainer":"TypesDisplay_mainContainer__LHD9r"};